import { apiFetch } from './client.js'

function normalizeDynamicRule(rule) {
  if (!rule || typeof rule !== 'object') {
    return null
  }

  return {
    id: rule.id,
    applicationId: rule.application_id || rule.applicationId,
    groupConfigId: rule.group_config_id || rule.groupConfigId || null,
    remoteConfigId: rule.remote_config_id || rule.remoteConfigId || null,
    name: rule.name || '',
    ruleType: rule.rule_type || rule.ruleType || 'Value',
    description: rule.description || '',
    placeholder: rule.placeholder || '',
    outputLabel: rule.output_label || rule.outputLabel || '',
    userParam: rule.user_param || rule.userParam || '',
    dynamicRuleElements: Array.isArray(rule.dynamic_rule_elements)
      ? rule.dynamic_rule_elements
      : Array.isArray(rule.dynamicRuleElements)
        ? rule.dynamicRuleElements
        : [],
    isEnabled: Boolean(rule.is_enabled ?? rule.isEnabled),
    createdAt: rule.created_at || rule.createdAt || null,
    updatedAt: rule.updated_at || rule.updatedAt || null,
  }
}

function extractList(payload) {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.items)) return payload.items
  if (Array.isArray(payload?.results)) return payload.results
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

function extractItem(payload) {
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    if (payload.item) return payload.item
    if (payload.data && !Array.isArray(payload.data)) return payload.data
  }
  return payload
}

export async function listDynamicRules(applicationId) {
  const payload = await apiFetch(`/apps/${encodeURIComponent(applicationId)}/dynamic-rules`)
  return extractList(payload).map(normalizeDynamicRule).filter(Boolean)
}

export async function getDynamicRule(applicationId, dynamicRuleId) {
  const payload = await apiFetch(
    `/apps/${encodeURIComponent(applicationId)}/dynamic-rules/${encodeURIComponent(dynamicRuleId)}`,
  )
  return normalizeDynamicRule(extractItem(payload))
}

export async function createDynamicRule(applicationId, values) {
  if (values?.groupConfigId == null || values?.groupConfigId === '') {
    throw new Error('Group config is required')
  }
  const payload = await apiFetch(`/apps/${encodeURIComponent(applicationId)}/dynamic-rules`, {
    method: 'POST',
    body: {
      group_config_id: Number(values.groupConfigId),
      name: String(values?.name || '').trim(),
      rule_type: String(values?.ruleType || 'Value').trim(),
      description: String(values?.description || '').trim(),
      placeholder: String(values?.placeholder || '').trim(),
      output_label: String(values?.outputLabel || '').trim(),
      user_param: String(values?.userParam || '').trim(),
      dynamic_rule_elements: Array.isArray(values?.dynamicRuleElements)
        ? values.dynamicRuleElements
        : [],
      is_enabled: Boolean(values?.isEnabled ?? true),
    },
  })
  return normalizeDynamicRule(extractItem(payload))
}

export async function updateDynamicRule(applicationId, dynamicRuleId, values) {
  const payload = await apiFetch(
    `/apps/${encodeURIComponent(applicationId)}/dynamic-rules/${encodeURIComponent(dynamicRuleId)}`,
    {
      method: 'PATCH',
      body: {
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'groupConfigId')
          ? { group_config_id: values.groupConfigId == null ? null : Number(values.groupConfigId) }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'name')
          ? { name: String(values.name || '').trim() }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'ruleType')
          ? { rule_type: String(values.ruleType || '').trim() }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'description')
          ? { description: String(values.description || '').trim() }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'placeholder')
          ? { placeholder: String(values.placeholder || '').trim() }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'outputLabel')
          ? { output_label: String(values.outputLabel || '').trim() }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'userParam')
          ? { user_param: String(values.userParam || '').trim() }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'dynamicRuleElements')
          ? {
              dynamic_rule_elements: Array.isArray(values.dynamicRuleElements)
                ? values.dynamicRuleElements
                : [],
            }
          : {}),
        ...(Object.prototype.hasOwnProperty.call(values || {}, 'isEnabled')
          ? { is_enabled: Boolean(values.isEnabled) }
          : {}),
      },
    },
  )
  return normalizeDynamicRule(extractItem(payload))
}

export async function deleteDynamicRule(applicationId, dynamicRuleId) {
  await apiFetch(`/apps/${encodeURIComponent(applicationId)}/dynamic-rules/${encodeURIComponent(dynamicRuleId)}`, {
    method: 'DELETE',
  })
}
